// extracted by mini-css-extract-plugin
export default {"strip":"TechStack_strip__afKsv","track":"TechStack_track__PHyBX","scroll":"TechStack_scroll__MHmtq","item":"TechStack_item__bAfhm","dot":"TechStack_dot__noN93"};